import { Accordion as BaseAccordion } from '@base-ui-components/react/accordion';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils';

const AccordionItem = BaseAccordion.Item;

const AccordionHeader = BaseAccordion.Header;

const Accordion = ({
  children,
  ...props
}: ComponentProps<typeof BaseAccordion.Root>) => (
  <BaseAccordion.Root hiddenUntilFound {...props}>
    {children}
  </BaseAccordion.Root>
);

const AccordionTrigger = ({
  className,
  children,
  ...props
}: ComponentProps<typeof BaseAccordion.Trigger>) => (
  <AccordionHeader>
    <BaseAccordion.Trigger
      data-name="accordion-trigger"
      className={cn('group flex items-baseline gap-2', className)}
      {...props}
    >
      {children}
    </BaseAccordion.Trigger>
  </AccordionHeader>
);

const AccordionContent = ({
  className,
  children,
  ...props
}: ComponentProps<typeof BaseAccordion.Panel>) => (
  <BaseAccordion.Panel
    className={cn(
      'h-[var(--accordion-panel-height)] overflow-hidden transition-[height] ease-out data-[ending-style]:h-0 data-[starting-style]:h-0',
      className
    )}
    {...props}
  >
    {children}
  </BaseAccordion.Panel>
);

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
